var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlightDeparture = function SvgFlightDeparture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.39 15.12A2 2 0 0 1 3 13.71L1.78 9.37A1.13 1.13 0 0 1 3.17 8c.192.05.369.15.511.29l1.84 1.88 3.15-.85-1.56-5.85a1.57 1.57 0 0 1 1.11-1.93A1.59 1.59 0 0 1 9.8 2l5.07 5.64 4.24-1.13a2.48 2.48 0 0 1 3 1.46 2.41 2.41 0 0 1-.18 2 2.38 2.38 0 0 1-1.45 1.11z"
  })));
};
export default SvgFlightDeparture;